import { createContext, useMemo, useState } from "react";

export interface GlobalAgentContextType {
  pageContext?: Record<string, unknown>;
  setPageContext: (context: Record<string, unknown> | undefined) => void;
}

export const GlobalAgentContext = createContext<GlobalAgentContextType>({
  pageContext: undefined,
  setPageContext: () => {},
});

export interface GlobalAgentProviderProps {
  children: React.ReactNode;
}

export function GlobalAgentProvider({ children }: GlobalAgentProviderProps) {
  const [pageContext, setPageContext] = useState<
    Record<string, unknown> | undefined
  >(undefined);

  const contextValue = useMemo(
    () => ({
      pageContext,
      setPageContext,
    }),
    [pageContext],
  );

  return (
    <GlobalAgentContext.Provider value={contextValue}>
      {children}
    </GlobalAgentContext.Provider>
  );
}
